import PublicHeader from './PublicHeader'

export default PublicHeader
